<template>
    <div :key="componentKey" class="pure-g">
       
        <div v-if="isLoading" class="pure-u-1"><div class="loading small"></div></div>
        <div v-if="!isLoading && members.length === 0" class="pure-u-1"><p class="empty">No members here yet.</p></div>

        <!--Leaderboard-->
        <div v-if="type === 'leaderboard' && allLeaderboardStaff !== null" class="pure-g membersList leaderboardList">
            <div class="pure-u-1 pure-u-lg-1-2 leaderboardListItem">
                <h3>Staff ({{ allLeaderboardStaff.length }})</h3>
                
                <div v-for="(member, memberIndex) in allLeaderboardStaff" :key="member.uid" class="pure-u-1 memberItem" :class="getDynamicClass(grid)">
                    
                    <p class="rank">{{ memberIndex + 1 }}</p>

                    <div class="avatar" :style="{backgroundImage: 'url('+ member.photoURL +')'}">
                        <MemberStatus :memberId="member.uid"></MemberStatus>
                    </div>
                
                    <div class="wrapper">

                        <p class="name">
                            <span v-if="member.phoneNumber !== null" class="verifiedBadge hint hint--top" data-hint="Account Secured"><ion-icon name="shield-checkmark"></ion-icon></span>
                            {{ member.displayName }}
                        </p>
                        <p class="title">
                            <span v-if="member.displayName === 'Anand Davaasuren'" class="badge staff">Organizer</span>
                            <span v-else-if="member.isStaff" class="badge staff">{{ member.staffTitle }}</span>
                            <span v-else-if="member.isMember" class="badge">Member</span>
                            <span v-else class="badge grey">User</span>
                        </p>

                        <!--Leaderboard-->
                        <div class="memberPoints">
                            <div class="memberPointsInner">

                                <div v-if="memberIndex < 3" class="trophyArea" :class="getDynamicRankClass(memberIndex)" :data-hint="getDynamicHint(memberIndex)">
                                    <ion-icon name="trophy"></ion-icon>
                                </div>
                                
                                <div class="pointsArea hint hint--top" data-hint="Points this year">
                                    <div>
                                        <p class="point">{{ member.points }}</p>
                                        <span>Points</span>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="pure-u-1 pure-u-lg-1-2 membersList leaderboardListItem">
                <h3>Members ({{ allLeaderboardMembers.length }})</h3>

                <div v-for="(member, memberIndex) in allLeaderboardMembers" :key="member.uid" class="pure-u-1 memberItem" :class="getDynamicClass(grid)">

                    <p class="rank">{{ memberIndex + 1 }}</p>

                    <div class="avatar" :style="{backgroundImage: 'url('+ member.photoURL +')'}">
                        <MemberStatus :memberId="member.uid"></MemberStatus>
                    </div>
                    
                    <div class="wrapper">
                        
                        <p class="name">
                            <span v-if="member.phoneNumber !== null" class="verifiedBadge hint hint--top" data-hint="Account Secured"><ion-icon name="shield-checkmark"></ion-icon></span>
                            {{ member.displayName }}
                        </p>
                        <p class="title">
                            <span v-if="member.displayName === 'Anand Davaasuren'" class="badge staff">Organizer</span>
                            <span v-else-if="member.isStaff" class="badge staff">{{ member.staffTitle }}</span>
                            <span v-else-if="member.isMember" class="badge">Member</span>
                            <span v-else class="badge grey">User</span>
                        </p>
                        
                        <!--Leaderboard-->
                        <div class="memberPoints">
                            <div class="memberPointsInner">

                                <div v-if="memberIndex < 3" class="trophyArea" :class="getDynamicRankClass(memberIndex)" :data-hint="getDynamicHint(memberIndex)">
                                    <ion-icon name="trophy"></ion-icon>
                                </div>
                                
                                <div class="pointsArea hint hint--top" data-hint="Points this year">
                                    <div>
                                        <p class="point">{{ member.points }}</p>
                                        <span>Points</span>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <!--MembersList-->
        <div v-else class="membersList pure-g">

            <div
                v-for="member in members"
                :key="member.uid"
                class="pure-u-1 memberItem Popover position-relative"
                :class="getDynamicClass(grid)"
            >
                <div class="Popover-message Popover-message--bottom p-3 mx-auto Box">
                    
                    <router-link :to="`/user/${member.uid}`" class="profileLink">
                        <div class="avatar xlarge mb-2" :style="{backgroundImage: 'url('+ member.photoURL +'?width=500&height=500)'}">
                            <MemberStatus :memberId="member.uid"></MemberStatus>
                        </div>
                        <h4 class="mb-1">
                            <span v-if="member.phoneNumber !== null" class="verifiedBadge hint hint--top" data-hint="Account Verified"><ion-icon name="shield-checkmark"></ion-icon></span>
                            {{ member.displayName }}
                        </h4>
                        <p class="mb-1" v-if="userHasLocation(member)">
                            {{ member.location.city.name }},
                            {{ member.location.state.name }}
                        </p>
                        
                        <p class="title">
                            <span v-if="member.displayName === 'Anand Davaasuren'" class="badge staff">Organizer</span>
                            <span v-else-if="member.isStaff" class="badge staff">{{ member.staffTitle }}</span>
                            <span v-else-if="member.isMember" class="badge yellow">Member</span>
                            <span v-else class="badge grey">User</span>
                        </p>
                    </router-link>

                    <MemberActions :member="member"></MemberActions>
                </div>

                <router-link :to="`/user/${member.uid}`" class="profileLink">
                    <div class="d-flex flex-items-center">
                        
                        <div
                            class="avatar"
                            :class="{
                                yellow: member.isMember,
                                grey: !member.isMember,
                                green: member.isStaff
                            }"
                            :style="{backgroundImage: 'url('+ member.photoURL +'?width=150&height=150)'}"
                        >
                            <MemberStatus :memberId="member.uid"></MemberStatus>
                        </div>
                        <div class="wrapper">
                            <p class="name">
                                {{ member.displayName }}
                            </p>
                            <p class="title">
                                <span v-if="member.displayName === 'Anand Davaasuren'" class="badge staff">Organizer</span>
                                <span v-else-if="member.isStaff" class="badge staff">{{ member.staffTitle }}</span>
                                <span v-else-if="member.isMember" class="badge yellow">Member</span>
                                <span v-else class="badge grey">User</span>
                            </p>
                        </div>
                        

                        <!--Admin-->
                        <div class="adminArea">
                            <p v-if="type === 'admin' && member.uid" class="adminInfo"><span>Uid:</span> {{ member.uid }}</p>
                            <p v-if="type === 'admin' && member.customerId" class="adminInfo"><span>CustomerId:</span> {{ member.customerId }}</p>
                            <p v-if="type === 'admin' && member.email" class="adminInfo"><span>Email:</span> {{ member.email }}</p>
                            <p v-if="type === 'admin' && member.phoneNumber" class="adminInfo"><span>PhoneNumber:</span> {{ member.phoneNumber | phoneNumber }}</p>

                            <div v-if="type === 'event' && isAdmin()" class="actionBtns">
                                <a href="#0" @click.prevent="removeMemberFromEvent(member.uid)" class="btn icon deleteBtn">
                                    <ion-icon name="trash"></ion-icon>
                                </a>
                            </div>
                            <div v-if="type === 'workshop' && isAdmin()" class="actionBtns">
                                <a href="#0" @click.prevent="removeMemberFromWorkshop(member.uid)" class="btn icon deleteBtn">
                                    <ion-icon name="trash"></ion-icon>
                                </a>
                            </div>
                            <div v-if="type === 'admin'" class="actionBtns">
                                <a href="#0" v-if="!member.customerId && member.email" @click="createCustomerId($event, member.uid, member.email)" class="btn green">Create Customer Id</a>
                                <a href="#0" @click="makeStaff($event, member.uid)" class="btn green" v-if="!member.isStaff">Make Staff</a>
                                <a href="#0" @click="revokeStaff($event, member.uid)" class="btn alert" v-else>Revoke Staff</a>
                                <a href="#0" @click.prevent="sendEmailTo(member.uid)" class="btn green" v-if="member.isMember === false && member.email !== null">Send Member Email</a>
                            </div>
                        </div>
                    </div>
                </router-link>
            </div>

            <!--Event Admin Actions-->
            <div v-if="(type === 'event' || type === 'admin' || type === 'workshop') && isAdmin()" class="pure-u-1 actionMembersList">
                
                <a href="#0" v-if="!initNonEventMembers" @click.prevent="initAllNonEventMembers()" class="btn secondary">Add Member</a>

                <!--Events-->
                <div v-if="initNonEventMembers && allNonEventMembers !== null" class="eventNonMembersList">
                    <h4>Add Members</h4>
                    <div v-for="member in allNonEventMembers" :key="member.uid" class="pure-u-1 memberItem" :class="getDynamicClass(grid)">

                        <div class="avatar" :style="{backgroundImage: 'url('+ member.photoURL +')'}">
                            <MemberStatus :memberId="member.uid"></MemberStatus>
                        </div>
                
                        <div class="wrapper">

                            <p class="name">
                                <span v-if="member.phoneNumber !== null" class="verifiedBadge hint hint--top" data-hint="Phone Number Added"><ion-icon name="shield-checkmark"></ion-icon></span>
                                {{ member.displayName }}
                            </p>

                            <p class="title">
                                <span v-if="member.displayName === 'Anand Davaasuren'" class="badge staff">Organizer</span>
                                <span v-else-if="member.isStaff" class="badge staff">{{ member.staffTitle }}</span>
                                <span v-else-if="member.isMember" class="badge">Member</span>
                                <span v-else class="badge grey">User</span>
                            </p>

                            <div class="actionBtns">
                                <a href="#0" @click.prevent="addMemberToEvent(member.uid)" class="btn icon addBtn">
                                    <ion-icon name="add"></ion-icon>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>

                <!--Workshops-->
                <div v-if="initNonWorkshopMembers && allNonWorkshopMembers !== null" class="eventNonMembersList">
                    <h4>Add Members</h4>
                    <div v-for="member in allNonWorkshopMembers" :key="member.uid" class="pure-u-1 memberItem" :class="getDynamicClass(grid)">

                        <div class="avatar" :style="{backgroundImage: 'url('+ member.photoURL +')'}">
                            <MemberStatus :memberId="member.uid"></MemberStatus>
                        </div>
                
                        <div class="wrapper">

                            <p class="name">
                                <span v-if="member.phoneNumber !== null" class="verifiedBadge hint hint--top" data-hint="Phone Number Added"><ion-icon name="shield-checkmark"></ion-icon></span>
                                {{ member.displayName }}
                            </p>

                            <p class="title">
                                <span v-if="member.displayName === 'Anand Davaasuren'" class="badge staff">Organizer</span>
                                <span v-else-if="member.isStaff" class="badge staff">{{ member.staffTitle }}</span>
                                <span v-else-if="member.isMember" class="badge">Member</span>
                                <span v-else class="badge grey">User</span>
                            </p>

                            <div class="actionBtns">
                                <a href="#0" @click.prevent="addMemberToWorkshop(member.uid)" class="btn icon addBtn">
                                    <ion-icon name="add"></ion-icon>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>

                <a href="#0" @click.prevent="notify.init = true" class="btn secondary">Notify {{ type }} Members</a>

                <div v-if="notify.init" class="adminNotifyArea">
                    <br/><br/>
                    <form>
                        <h4>Notify {{ type }} members</h4>
                        <select v-model="notify.type">
                            <option value="email" selected="selected">Email</option>
                            <option value="sms">Sms</option>
                        </select>
                        <input type="text" placeholder="Subject" v-model="notify.subject" />
                        <textarea v-model="notify.message" placeholder="Message"></textarea>
                        <input @click.prevent="notifyAllEventMembers" v-if="notify.loading === false && notify.subject !== '' && notify.message !== ''" type="submit" value="Send Notification" class="btn green" />
                        <div v-if="notify.loading && !notify.success" class="loading small no-margin"></div>
                        <p v-if="!notify.loading && notify.success">Notification sent successfully</p>
                    </form>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import moment from 'moment'
const fb = require('@/firebaseConfig.js')
import MemberStatus from '@/components/MemberStatus'
import MemberActions from '@/components/MemberActions'

export default {
    components: {
        MemberStatus,
        MemberActions
    },
    data(){
        return{
            allUsersObj: {},
            allMembersObj: {},
            allNonMembersObj: {},
            allMembers: null,
            allNonMembers: null,
            allLeaderboardMembers: null,
            allLeaderboardStaff: null,
            members: [],
            isLoading: false,
            componentKey: 0,
            allMemberPoints: {},
            initNonEventMembers: false,
            initNonWorkshopMembers: false,
            allEventMembersObj: {},
            allWorkshopMembersObj: {},
            allNonEventMembers: null,
            allNonWorkshopMembers: null,
            notify: {
                init: false,
                loading: false,
                success: false,
                type: 'email',
                subject: '',
                message: ''
            }
        }
    },
    props: {
        'type': String,
        'eventId': String,
        'workshopId': String,
        'grid': String,
        'max': Number,
        'data': Object
    },
    beforeMount(){
        if(this.data){
            // console.log('Data points: ', this.data)
            this.allMemberPoints = this.data
        }
    },

    mounted(){
        this.getAllMembers()
    },

    methods: {
        forceRerender(){
            this.$forceUpdate()
            this.componentKey += 1
        },
        isAdmin(){
            let isAdminActions = false

            if(this.$store.state.currentUser !== null){
                if(this.$store.state.currentUser.uid === 'MxARUElzBNhyyJbdwYkOL55vxxJ2'){
                    isAdminActions = true
                }
            }

            return isAdminActions
        },
        getAllMembers(){

            let self = this
            let query = true

            if(this.$store.state.allUsersNew !== null){
                if(this.$store.state.allUsersNew.length > 0){
                    query = false
                }
            }

            self.isLoading = true

            if(query){
                // console.log('Get MembersList from Database.')

                fb.usersCollection
                    .orderBy('timestamp', 'desc')
                    .get()
                    .then(function(snap){

                        let listOfMembers = []
                        let listNonMembers = []
                        
                        snap.forEach(member => {
                            let memberData = member.data()
                            self.allUsersObj[member.id] = memberData

                            if(memberData.isMember === true){
                                self.allMembersObj[member.id] = memberData
                                listOfMembers.push(memberData)
                            }else{
                                self.allNonMembersObj[member.id] = memberData
                                listNonMembers.push(memberData)
                            }
                        })
                        
                        self.allMembers = listOfMembers
                        self.allNonMembers = listNonMembers

                        self.nextStep()

                }).catch(err => {
                    console.log('Error getting all members: ', err.message)
                })
            }else{
                // console.log('Use MembersList from Store.')

                let listOfMembers = []
                let listNonMembers = []

                let membersData = this.$store.state.allUsersNew        
                
                membersData.forEach(member => {
                    let memberData = member

                    self.allUsersObj[member.uid] = memberData

                    if(memberData.isMember === true){
                        self.allMembersObj[member.uid] = memberData
                        listOfMembers.push(memberData)
                    }else{
                        self.allNonMembersObj[member.uid] = memberData
                        listNonMembers.push(memberData)
                    }
                })
                
                self.allMembers = listOfMembers
                self.allNonMembers = listNonMembers

                self.nextStep()
            }
        },
        nextStep(){
            let self = this

            if(self.type === 'latest'){
                self.getLatestMembers()
            }else if(self.type === 'latestUsers'){
                self.getLatestUsers()
            }else if(self.type === 'event'){
                self.getEventMembers(self.type)
            }else if(self.type === 'workshop'){
                self.getWorkshopMembers(self.type)
            }else if(self.type === 'staff'){
                self.getStaffMembers()
            }else if(self.type === 'admin'){
                self.getAllUsers()
            }else if(self.type === 'leaderboard'){
                self.getAllLeaderboardMembers()
            }else{
                self.isLoading = false
            }
        },
        getLatestMembers(){
            if(this.max !== null){
                this.members = (this.allMembers).slice(0, this.max)
            }else{
                this.members = this.allMembers
            }
            this.isLoading = false
        },
        getLatestUsers(){
            if(this.max !== null){
                this.members = (this.allNonMembers).slice(0, this.max)
            }else{
                this.members = this.allNonMembers
            }
            this.isLoading = false
        },
        getEventMembers(type){

            let self = this
            let membersRef = null
            
            if(type === 'workshop'){
                membersRef = fb.workshopsCollection.doc(self.workshopId).collection('members')
            }else{
                membersRef = fb.eventsCollection.doc(self.eventId).collection('members')
            }

            if(membersRef !== null){
                membersRef.get().then(snap => {

                    let listOfMembers = []
                        
                    snap.forEach(function(member){

                        let memberData = member.data()
                        
                        self.allMembersObj[member.id].isJoined = memberData.isJoined
                        self.allMembersObj[member.id].transactions = memberData.transactions
                        self.allMembersObj[member.id].status = memberData.status

                        if(type === 'event'){
                            self.allEventMembersObj[member.id] = self.allMembersObj[member.id]
                        }else if(type === 'workshop'){
                            self.allWorkshopMembersObj[member.id] = self.allMembersObj[member.id]
                        }

                        listOfMembers.push(self.allMembersObj[member.id])
                    })

                    self.members = listOfMembers
                    self.isLoading = false
                }).catch(err => {
                    console.log('Error getting event data: ', err.message)
                    self.isLoading = false
                })
            }
        },
        getWorkshopMembers(type){

            let self = this
            let membersRef = fb.workshopsCollection.doc(self.workshopId).collection('members')

            membersRef.get().then(snap => {

                let listOfMembers = []

                snap.forEach(function(member){

                    let memberData = member.data()

                    if(memberData.isJoined){
                        self.allUsersObj[member.id].isJoined = memberData.isJoined
                    }
                    if(memberData.transactions){
                        self.allUsersObj[member.id].transactions = memberData.transactions
                    }
                    if(memberData.status){
                        self.allUsersObj[member.id].status = memberData.status
                    }

                    self.allWorkshopMembersObj[member.id] = self.allUsersObj[member.id]

                    listOfMembers.push(self.allWorkshopMembersObj[member.id])
                })

                self.members = listOfMembers
                self.isLoading = false

            }).catch(err => {
                console.log('Error getting workshop members: ', err.message)
                self.loading = false
            })
        },
        removeMemberFromEvent(memberId){

            let self = this

            if(confirm('Are you sure you want to remove member from event?')){

                let eventMemberRef = fb.eventsCollection.doc(self.eventId).collection('members').doc(memberId)
                let userEventJoinedRef = fb.usersCollection.doc(memberId).collection('joinedEvents').doc(self.eventId)

                eventMemberRef.delete().then(() => {
                    userEventJoinedRef.delete().then(function(){
                        self.getEventMembers()
                        self.initAllNonEventMembers()
                    })
                })
            }
        },
        removeMemberFromWorkshop(memberId){

            let self = this

            if(confirm('Are you sure you want to remove member from event?')){

                let workshopMemberRef = fb.workshopsCollection.doc(self.workshopId).collection('members').doc(memberId)
                let userWorkshopJoinedRef = fb.usersCollection.doc(memberId).collection('joinedWorkshops').doc(self.workshopId)

                workshopMemberRef.delete().then(() => {
                    userWorkshopJoinedRef.delete().then(() => {
                        self.getWorkshopMembers()
                        self.initAllNonEventMembers()
                    })
                })
            }
        },
        initAllNonEventMembers(){

            let self = this
            let allCurrentNonEventMembers = []
            let allCurrentNonWorkshopMembers = []

            if(self.type === 'event'){

                Object.keys(self.allMembersObj).forEach((key, index) => {

                    let member = self.allMembersObj[key]

                    if(typeof(self.allEventMembersObj[key]) === 'undefined'){
                        allCurrentNonEventMembers.push(member)
                    }
                })
            
                self.allNonEventMembers = allCurrentNonEventMembers
                self.initNonEventMembers = true

            }else if(self.type === 'workshop'){

                Object.keys(self.allUsersObj).forEach((key, index) => {

                    let member = self.allUsersObj[key]

                    console.log('User: '+ member.displayName)

                    if(typeof(self.allWorkshopMembersObj[key]) === 'undefined'){
                        allCurrentNonWorkshopMembers.push(member)
                    }
                })

                self.allNonWorkshopMembers = allCurrentNonWorkshopMembers
                self.initNonWorkshopMembers = true
            }
        },
        addMemberToEvent(memberId){
            
            let self = this

            let eventJoinedRef = fb.eventsCollection.doc(this.eventId).collection('members').doc(memberId)
            let userEventJoinedRef = fb.usersCollection.doc(memberId).collection('joinedEvents').doc(this.eventId)

            let joinedData = {
                isJoined: true,
                paymentId: null,
                status: 'Going',
                timestamp: fb.firebase.firestore.FieldValue.serverTimestamp()
            }

            eventJoinedRef.set(joinedData).then(function(){
                userEventJoinedRef.set(joinedData).then(function(){

                    self.getEventMembers()
                    self.initAllNonEventMembers()
                })
            }).catch(err => {
                console.log('Error saving member in event')
            })
        },
        addMemberToWorkshop(memberId){

            let self = this
            let workshopJoinedRef = fb.workshopsCollection.doc(this.workshopId).collection('members').doc(memberId)
            let userWorkshopJoinedRef = fb.usersCollection.doc(memberId).collection('joinedWorkshops').doc(this.workshopId)

            let joinedData = {
                isJoined: true,
                paymentId: null,
                status: 'Going',
                timestamp: fb.firebase.firestore.FieldValue.serverTimestamp()
            }

            workshopJoinedRef.set(joinedData).then(function(){
                userWorkshopJoinedRef.set(joinedData).then(function(){
                    self.getWorkshopMembers()
                    self.initAllNonEventMembers()
                })
            }).catch(err => {
                console.log('Error saving member in workshop')
            })
        },
        getStaffMembers(){

            let self = this
            let allStaff = []
            let allOrganizers = []

            self.allMembers.forEach(function(member){
                if(member.isMember === true && member.isStaff === true){
                    allStaff.push(member)
                }
            })

            allStaff.sort((a, b) => (a.staffOrder > b.staffOrder) ? 1 : -1)

            self.members = allStaff
            self.isLoading = false
        },
        getAllUsers(){

            let self = this

            self.members = (self.allMembers).concat(self.allNonMembers)
            self.isLoading = false

        },
        getAllLeaderboardMembers(){

            let self = this
            let currentLeaderboardMembers = []
            let currentLeaderboardStaff = []

            console.log('Data points 2: ', this.allMemberPoints)

            self.allMembers.forEach(member => {
                
                let newMemberData = member

                // Members
                if(member.isMember === true && !member.isStaff){
                    
                    if(typeof(this.allMemberPoints[member.uid]) !== 'undefined'){
                        if(this.allMemberPoints[member.uid].points !== null){
                            newMemberData.points = this.allMemberPoints[member.uid].points

                            console.log('Member point: ', this.allMemberPoints[member.uid].points)
                        }
                    }

                    currentLeaderboardMembers.push(newMemberData)
                
                // Staff
                }else if(member.isMember === true && member.isStaff === true){

                    if(typeof(self.allMemberPoints[member.uid]) !== 'undefined'){
                        if(this.allMemberPoints[member.uid].points !== null){
                            newMemberData.points = self.allMemberPoints[member.uid].points
                        }
                    }
                    if(member.uid !== 'MxARUElzBNhyyJbdwYkOL55vxxJ2'){
                        currentLeaderboardStaff.push(newMemberData)
                    }
                }
            })

            currentLeaderboardMembers.sort((a, b) => (b.points > a.points) ? 1 : -1)
            currentLeaderboardStaff.sort((a, b) => (b.points > a.points) ? 1 : -1)

            self.members = currentLeaderboardMembers
            self.allLeaderboardMembers = currentLeaderboardMembers
            self.allLeaderboardStaff = currentLeaderboardStaff

            console.log('Leaderboard members: ', currentLeaderboardMembers)

            self.isLoading = false    
        },
        getDynamicClass(gridType){

            let dynamicClass = ''

            if(gridType !== null){
                if(gridType == '4'){
                    dynamicClass = 'pure-u-md-1-3 pure-u-lg-1-4'
                }
            }else{
                dynamicClass = ''
            }   
            if(this.type === 'admin'){
                dynamicClass += ' admin'
            }

            return dynamicClass
        },
        getDynamicRankClass(rank){

            let dynamicClass = ''

            if(rank < 3){
                dynamicClass += 'hint hint--top '
                if(rank === 0){
                    dynamicClass += 'gold'
                }else if(rank === 1){
                    dynamicClass += 'bronze'
                }else if(rank === 2){
                    dynamicClass += 'silver'
                }
            }

            return dynamicClass
        },
        getDynamicHint(rank){
            let dynamicHint = ''

            if(rank < 3){
                if(rank === 0){
                    dynamicHint = 'Gold'
                }else if(rank === 1){
                    dynamicHint = 'Bronze'
                }else if(rank === 2){
                    dynamicHint = 'Silver'
                }
            }

            return dynamicHint
        },
        createCustomerId(e, memberId, email){
            e.preventDefault()

            console.log('Create customer id for member: ', memberId)

            let self = this
            let customerOptions = {
                email: email
            }
            let userRef = fb.usersCollection.doc(memberId)

            self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/CreateStripeCustomer', customerOptions).then(response => {
                if(response.status === 200){
                    
                    userRef.update({
                        customerId: response.body.id
                    }).then(function() {
                        console.log("Customer id saved to user profile successfully!")
                    }).catch(function(error) {
                        console.error("Error updating document: ", error)
                    })
                }
            })
            .catch((err) => {
                console.log('Error creating new stripe customer! ', err)
            })
        },
        makeStaff(e, memberId){
            e.preventDefault()

            let self = this
            let userRef = fb.usersCollection.doc(memberId)

            console.log('Make member a staff: ', memberId)

            userRef.update({
                isStaff: true,
                staffOrder: 2,
                staffTitle: 'Co-Organizer',
                staffEmail: ''
            }).then(function(){

                console.log('Updated staff')
                self.forceRerender()

            }).catch(function(err){
                console.log('Error making member a staff: ', err)
            })
        },
        revokeStaff(e, memberId){
            e.preventDefault()

            console.log('Revoke member :', memberId)

            let self = this
            let userRef = fb.usersCollection.doc(memberId)

            userRef.update({
                isStaff: false
            }).then(function(){
                
                console.log('Updated staff')
                self.forceRerender()

            }).catch(function(err){
                console.log('Error updating staff: ', err)
            })
        },
        async sendEmailTo(memberId, type){

            let self = this
            let userObj = self.allUsersObj[memberId]

            console.log('Send email to: ', userObj)

            let email = userObj.email
            let firstName = userObj.firstName

            if(typeof(email) === 'undefined'){
                return {
                    status: 'error',
                    message: 'No email found',
                    firstName: firstName
                }
            }

            let subject = 'OneMgl - 1 More step to become a member.'
            let messageContent = 'Thank you for registering to OneMgl.<br/><br/>There is only 1 more step remaining to become our member!<br/><br/><a href="https://www.onemgl.com/welcome1">Click here</a> to become a member now.'
            let messageHeader = 'Hello '+ firstName +', <br/><br/>' 
            let messageFooter = '<br/><br/>Kind Regards<br>OneMgl Community<br>www.onemgl.com'
            let message = messageHeader + messageContent + messageFooter

            if(typeof type !== 'undefined'){
                subject = type.subject
                message = messageHeader + type.message + messageFooter
            }

            let options = {
                email: email,
                fromEmail: 'info@onemgl.com',
                subject: subject,
                text: message,
                html: '<p>'+ message +'</p>'
            }

            return self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/SendMail', options).then(response => {
                console.log('Email sent response: ', response)
                return response
            }).catch((err) => {
                console.log('Email send error response: ', err)
                return err
            })
        },
        async sendSmsTo(memberId, type){

            let self = this
            let userObj = self.allUsersObj[memberId]

            console.log('Send sms to: ', userObj)

            let phoneNumber = userObj.phoneNumber
            let firstName = userObj.firstName

            if(typeof(phoneNumber) === 'undefined'){
                return {
                    status: 'error',
                    message: 'No phone number found',
                    firstName: firstName
                }
            }

            let messageHeader = 'Hello '+ firstName + ','
            let messageFooter = 'Kind Regards OneMgl Community'
            let message = messageHeader + ' | '+ type.subject + ' | ' + type.message + ' | ' + messageFooter

            let options = {
                phoneNumber: phoneNumber,
                message: message
            }

            return self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/SendTxt', options).then(response => {
                return response
            }).catch((err) => {
                return err
            })
        },
        setupUserSettings(){

            let self = this
            let batch = fb.db.batch()

            Object.keys(self.allUsersObj).forEach((key, index) => {
                
                let user = self.allUsersObj[key]
                let userRef = fb.usersCollection.doc(user.uid)

                let sendEmail = false
                let sendTxt = false

                if(user.email !== null){
                    sendEmail = true
                }
                if(user.phoneNumber !== null){
                    sendTxt = true
                }

                batch.update(userRef, {
                    'settings': {
                        'sendEmail': sendEmail,
                        'sendTxt': sendTxt
                    }
                })

                console.log('User: ', user.displayName)
            })

            batch.commit().then(function(){
                console.log('Batch successfull!')
            })
        },
        async notifyAllEventMembers(){

            let self = this

            self.notify.loading = true

            console.log('Prepare event notifications to: ', self.members, self.notify.subject, self.notify.message)      

            for(let i = 0; i < self.members.length; i++){
                
                let member = self.members[i]
                let sendNotification = null
                
                if(typeof(member.phoneNumber) !== 'undefined' && member.phoneNumber !== null){
                    
                    sendNotification = await self.sendSmsTo(member.uid, {
                        subject: self.notify.subject,
                        message: self.notify.message
                    })
                    
                    if(sendNotification.status === 200){
                        console.log('Sent sms notification to: '+ member.firstName, member.phoneNumber, sendNotification)  
                    }else{
                        console.log('Send sms notification error: '+ member.firstName, member.phoneNumber, sendNotification)
                    }

                }else if(typeof(member.email) !== 'undefined' && member.email !== null){
                    
                    sendNotification = await self.sendEmailTo(member.uid, {
                        subject: self.notify.subject,
                        message: self.notify.message
                    })

                    if(sendNotification.status === 200){
                        console.log('Sent email notification to: '+ member.firstName, member.email, sendNotification)  
                    }else{
                        console.log('Send email notification error: '+ member.firstName, member.email, sendNotification)
                    }
                }
            }

            self.notify.loading = false
            self.notify.success = true
            self.notify.type = 'email'
            self.notify.subject = ''
            self.notify.message = ''

            console.log('All notifications sent!')
        },
        checkLastOnlineTime(user, offline){
            if(user.status === 'online') return null
            
            let today = moment()
            let lastOnline = moment(user.timestamp)
            let min = today.diff(lastOnline, 'minutes')

            if(offline === 'offline'){
                return lastOnline.format('MMM D, YYYY - h:mm a')
            }

            if(min < 60){
                return min + 'm'
            }

            return null
        },
        userHasLocation(member){
            if(typeof member.location !== 'undefined' && member.location !== null){
                if(typeof member.location.city !== 'undefined' && member.location.city !== null){
                    return true
                }
            }
            return false
        }
    },
    filters: {
        phoneNumber(value){
            if(!value) return
            let cleaned = ('' + value).replace(/\D/g, '')
            let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3]
            }
            return
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/MembersList.vue